import { useEffect, useState } from "react";
import DefaultApiService from "../../../infrastructure/api/default";
import RequestAssignmentApi from "../../../infrastructure/api/requestAssignment";
import {
  ASSIGNMENT_FILTER_OPTIONS_MANAGEMENT,
  enrichAssignmentRows,
  inferAssignmentFeatureFromRows,
  persistUserIdentityToStorage,
  setAssignmentUserContext,
} from "./requestAssignmentDisplay";
import {
  drillDownParamsToApiQuery,
} from "../../pages/SLN/management/all-request/allRequestDrillDownUtils";
import {
  DEFAULT_PAGE_SIZE,
  parseAllRequestPagedResponse,
} from "../../pages/SLN/management/all-request/allRequestPaginationUtils";

export { parseAllRequestPagedResponse };

export const useManagementAllRequestPagedList = (
  apiPath,
  listParams,
  assignmentFilter = "all",
  reloadToken = 0,
  options = {}
) => {
  const assignmentSource = options.assignmentSource || "Management";
  const assignmentFilterOptions =
    options.filterOptions || ASSIGNMENT_FILTER_OPTIONS_MANAGEMENT;
  const [rows, setRows] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pageMeta, setPageMeta] = useState({
    pageNumber: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    totalPages: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [featureEnabled, setFeatureEnabled] = useState(false);
  const [canClaimRequests, setCanClaimRequests] = useState(false);

  useEffect(() => {
    let cancelled = false;
    RequestAssignmentApi.getStatus(assignmentSource).then((status) => {
      if (!cancelled) {
        setFeatureEnabled(status.enabled);
        setCanClaimRequests(status.canClaimRequests);
        setAssignmentUserContext({
          canClaimRequests: status.canClaimRequests,
          currentUserKind: status.currentUserKind,
          currentUserId: status.currentUserId,
        });
        persistUserIdentityToStorage({
          userKind: status.currentUserKind,
          userId: status.currentUserId,
        });
      }
    });
    return () => {
      cancelled = true;
    };
  }, [assignmentSource]);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const query = {
          ...drillDownParamsToApiQuery(listParams),
          ...(assignmentFilter ? { assignmentFilter } : {}),
        };
        const res = await DefaultApiService.getListApi(apiPath, query);
        if (cancelled) return;

        if (res?.isSuccess === false) {
          setRows([]);
          setTotalCount(0);
          setError(res?.message || "دریافت لیست ناموفق بود.");
          return;
        }

        const page = parseAllRequestPagedResponse(res);
        const nextRows = enrichAssignmentRows(page.items);
        setRows(nextRows);
        setTotalCount(page.totalCount);
        setPageMeta({
          pageNumber: page.pageNumber,
          pageSize: page.pageSize,
          totalPages: page.totalPages,
          hasPreviousPage: page.hasPreviousPage,
          hasNextPage: page.hasNextPage,
        });
        if (inferAssignmentFeatureFromRows(nextRows)) {
          setFeatureEnabled(true);
        }
      } catch {
        if (!cancelled) {
          setRows([]);
          setTotalCount(0);
          setError("خطا در ارتباط با سرور هنگام دریافت لیست.");
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, [apiPath, listParams, assignmentFilter, reloadToken]);

  return {
    rows,
    totalCount,
    pageMeta,
    loading,
    error,
    featureEnabled,
    canClaimRequests,
    showAssignmentUi: featureEnabled,
    filterOptions: assignmentFilterOptions,
  };
};
